(() => {
  const initSkinAnalysis = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('#TapSkinAnalysisForm');
    const steps = [...root.querySelectorAll('[data-step]')];
    if (!form || !steps.length) return;

    const nextButton = root.querySelector('[data-next]');
    const prevButton = root.querySelector('[data-prev]');
    const submitButton = root.querySelector('[data-submit]');
    const progressBar = root.querySelector('[data-progress-bar]');
    const stepLabel = root.querySelector('[data-step-label]');
    const stepName = root.querySelector('[data-step-name]');
    const concernError = root.querySelector('[data-concern-error]');
    const concernInputs = [...root.querySelectorAll('[data-concern]')];

    const stepNames = ['About You', 'Your Skin', 'Your Routine', 'Final Details'];
    let currentStep = 0;

    const updateUI = () => {
      steps.forEach((step, index) => step.classList.toggle('is-active', index === currentStep));

      if (stepLabel) stepLabel.textContent = `Step ${currentStep + 1} of ${steps.length}`;
      if (stepName) stepName.textContent = stepNames[currentStep] || '';
      if (progressBar) progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;

      if (prevButton) prevButton.hidden = currentStep === 0;
      if (nextButton) nextButton.hidden = currentStep === steps.length - 1;
      if (submitButton) submitButton.hidden = currentStep !== steps.length - 1;

      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const validateCurrentStep = () => {
      const step = steps[currentStep];
      const requiredFields = [...step.querySelectorAll('[required]')];

      for (const field of requiredFields) {
        if (!field.checkValidity()) {
          field.reportValidity();
          return false;
        }
      }

      if (currentStep === 1 && concernInputs.length) {
        const hasConcern = concernInputs.some((input) => input.checked);
        concernError?.classList.toggle('is-visible', !hasConcern);
        if (!hasConcern) {
          concernInputs[0]?.focus();
          return false;
        }
      }

      return true;
    };

    nextButton?.addEventListener('click', () => {
      if (!validateCurrentStep()) return;
      currentStep = Math.min(currentStep + 1, steps.length - 1);
      updateUI();
    });

    prevButton?.addEventListener('click', () => {
      currentStep = Math.max(currentStep - 1, 0);
      updateUI();
    });

    concernInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (concernInputs.some((item) => item.checked)) {
          concernError?.classList.remove('is-visible');
        }
      });
    });

    form.addEventListener('submit', (event) => {
      if (!validateCurrentStep()) {
        event.preventDefault();
      }
    });

    updateUI();
  };

  const initAll = () => {
    document.querySelectorAll('[data-tap-skin-analysis]').forEach(initSkinAnalysis);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
